module.exports = __webpack_public_path__ + "static/media/aside_trienlam2023.3870b897.jpg";